import i18n from '../i18n';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { setRootBackHandler } from '../lib/overlayHistory';

/**
 * Double-press-to-leave for the back button.
 *
 * With no dialog open, one back press would unload the app — on a phone that
 * means losing the screen you were on. Instead the first press warns and
 * re-arms the history entry; a second press within the window lets go.
 */
export default function useBackGuard(windowMs = 2000) {
  useEffect(() => {
    // A sentinel entry so the very first press has something to pop.
    window.history.pushState({ __appRoot: true }, '');
    let armed = false;
    let timer = null;

    setRootBackHandler(() => {
      if (armed) {
        armed = false;
        window.history.back();
        return;
      }
      armed = true;
      window.history.pushState({ __appRoot: true }, '');
      toast(i18n.t('auto.misc3.pressBackAgainToLeave'), { duration: windowMs });
      clearTimeout(timer);
      timer = setTimeout(() => { armed = false; }, windowMs);
    });

    return () => {
      clearTimeout(timer);
      setRootBackHandler(null);
    };
  }, [windowMs]);
}
